import { useTopBar } from '@/features/calls/viewmodels';
import useCallTimer from '@/features/calls/viewmodels/useCallTimer';
import { useLanguage } from '@/localization/useLanguage';
import { LayoutGrid, PanelRight } from 'lucide-react';
import PropTypes from 'prop-types';
import styles from './TopBar.module.scss';
import { IconAddInvite, IconArrowLeft, IconPeople } from '@/assets/images';

/**
 * Pure rendering component — zero business logic.
 * Cross-feature fix: GroupCallSelectionPopup imported from @/shared/components, not features/chats.
 * All state (invite popup, remoteUser derivation) from useTopBar().
 */
export default function TopBar({ onParticipantsPanel }) {
   const { t } = useLanguage();
   const {
      ongoingCallParticipants,
      participantCount,
      toggleInvitePopup,
      minimizeCall,
      viewMode,
      toggleViewMode,
      callTitle,
   } = useTopBar();

   // Determine if we are in a 1-to-1 context to hide grid view toggle
   const callTimer = useCallTimer();

   return (
      <header className={`${styles.topbar} ct-flex ct-aiCenter ct-jcBetween`}>
         <div className={`${styles.left} ct-flex ct-aiStart ct-gap16`}>
            <button className={`${styles.infoBtn} ct-flexCenter`} aria-label={t('common.BACK')} onClick={minimizeCall}>
               <i className="ct-icon sm">
                  <IconArrowLeft />
               </i>
            </button>
            <div className={`${styles.meta} ct-flex ct-fcol ct-gap8`}>
               <h1 className={styles.title} id="call-screen-title">
                  {callTitle}
               </h1>
               <div className={`${styles.sub} ct-flex ct-aiCenter ct-gap8`}>
                  <span className={styles.timer}>{callTimer}</span>
               </div>
            </div>
         </div>

         <div className={`${styles.right} ct-flex ct-aiCenter ct-gap16`}>
            {ongoingCallParticipants?.length > 2 && (
               <button
                  className={`${styles.infoBtn} ct-flexCenter`}
                  aria-label={t('common.ADJUST_VIEW')}
                  onClick={toggleViewMode}
               >
                  <i className="ct-icon sm">{viewMode === 'tiled' ? <PanelRight /> : <LayoutGrid />}</i>
               </button>
            )}
            <button className={`${styles.infoBtn} ct-flexCenter`} onClick={onParticipantsPanel}>
               <div className={`${styles.iconWithBadge} ct-flex ct-aiCenter ct-jcCenter`}>
                  <i className="ct-icon sm">
                     <IconPeople />
                  </i>
                  {participantCount > 0 && <span className={styles.badge}>{participantCount}</span>}
               </div>
            </button>
            <button className={`${styles.infoBtn} ct-flexCenter`} onClick={toggleInvitePopup}>
               <i className="ct-icon sm">
                  <IconAddInvite />
               </i>
            </button>
         </div>
      </header>
   );
}

TopBar.propTypes = {
   onParticipantsPanel: PropTypes.func,
};
